import Module from '../utils/Module'

export default class ShareModule extends Module {
  constructor (options) {
    super(options)
    this.init();

  }

  init () {
    this.share = document.querySelectorAll('.share-buttons a');
    this.share.forEach((button, index) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        let buttonType = button.getAttribute('data-type');

        switch(buttonType) {
          case 'clipboard':
            /* https://stackoverflow.com/questions/53003980/how-to-copy-a-hypertext-link-into-clipboard-with-javascript-and-preserve-its-lin */
            const link = button;
            const range = document.createRange();
            range.selectNode(link);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            const successful = document.execCommand('copy');
            var copiedConfirmation = button.parentElement.querySelector('.box-copied');

            copiedConfirmation.classList.remove('visually-hidden');

            var copiedConfirmationRemoved = setTimeout(function(){
              copiedConfirmation.classList.add('visually-hidden');
            }, 5000);
            break;
          default:
            window.open(e.target.href, 'shareWindow', 'height=450, width=550, top=' + (window.innerHeight / 2 - 275) + ', left=' + (window.innerWidth / 2 - 225) + ', toolbar=0, location=0,' +
              ' menubar=0, directories=0, scrollbars=0');
            return false;
        }
      });
    });
  }
}
